import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyServiceRankingForm } from 'src/app/classes/form-groups/company-service-ranking-form';
import { CompanyServiceRanking } from 'src/app/classes/models';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-spotlight-vendor-ranking',
  templateUrl: './add-edit-spotlight-vendor-ranking-modal.component.html',
  styleUrls: ['./add-edit-spotlight-vendor-ranking-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditSpotlightVendorRankingModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private CompanyService: CompanyService,
    private UtilityService: UtilityService,
    private ToastService: ToastService
  ) {}

  @Input() CompanyServiceRankingId?: number;

  companyServiceRankingForm: CompanyServiceRankingForm =
    new CompanyServiceRankingForm();
  priorities: string[] = ['1', '2', '3', '4', '5'];

  // Used by the template to swap the header title between "Add" and
  // "Edit" without each caller having to wire it manually.
  get isEdit(): boolean {
    return !!this.CompanyServiceRankingId;
  }

  close(result?: any) {
    this.activeModal.close(result);
  }

  save() {
    this.CompanyService.saveCompanyServiceRanking(
      this.companyServiceRankingForm.getRawValue()
    ).subscribe({
      next: (CompanyServiceRanking: CompanyServiceRanking) => {
        if (CompanyServiceRanking) {
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully saved Vendor Ranking!'
          );
          this.close();
        }
      }
    });
  }

  onTradeOrTradeCategoryChange(
    controlName: 'isTradeSpecific' | 'isTradeCategorySpecific'
  ) {
    const isTradeSpecificFormControl =
      this.companyServiceRankingForm.controls.isTradeSpecific;
    const isTradeCategorySpecificFormControl =
      this.companyServiceRankingForm.controls.isTradeCategorySpecific;

    if (controlName === 'isTradeSpecific') {
      if (isTradeSpecificFormControl.value) {
        isTradeCategorySpecificFormControl.patchValue(false);
      }
    } else if (controlName === 'isTradeCategorySpecific') {
      if (isTradeCategorySpecificFormControl.value) {
        isTradeSpecificFormControl.patchValue(false);
      }
    }
  }

  ngOnInit(): void {
    if (this.CompanyServiceRankingId) {
      const companyServiceRankingQuery = {
        attributes: [
          'id',
          'rank',
          'priorityLevel',
          'isTradeCategorySpecific',
          'isTradeSpecific'
        ],
        id: this.CompanyServiceRankingId
      };

      this.CompanyService.getCompanyServiceRanking(
        this.UtilityService.stringifyObjectsInQueryObject(
          companyServiceRankingQuery
        )
      ).subscribe({
        next: (CompanyServiceRanking: CompanyServiceRanking) => {
          if (!CompanyServiceRanking) {
            throw this.ToastService.addErrorToast(
              'Error',
              'No CompanyServiceRanking record found for given ID.',
              { returnError: true }
            );
          }

          this.companyServiceRankingForm.patchValue(CompanyServiceRanking);
        }
      });
    }
  }
}
